import { useState, useEffect, useRef } from "react";
import Config from "../../../../Config";
import InputText from "../../../../helpers/InputText";
import InputChecbox from "../../../../helpers/InputCheckbox";

import back from "../../../../back.png";



// Etapy: form -> wait (certbot startuje) -> dns (dodaj rekordy TXT) -> wait -> done / error
function SslForm(props)
{
    const [row, setRow] = useState({
        domena: '',
        wildcard: false,
    });

    const [step, setStep] = useState('form');
    const [token, setToken] = useState(null);
    const [challenges, setChallenges] = useState([]);
    const [log, setLog] = useState('');
    const [queued, setQueued] = useState(false);

    const timerRef = useRef(null);



    const valChangeListener = (filedName, val, correct, msg) => {
            if(filedName == 'wildcard') val = correct;
            setRow( {...row, [filedName]:val } );
    }

    const goNextNew = () => {
    }



    const request = (action, body, onOk) => {

        fetch( Config.url + '/rest_v1_tools,' + action, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);
                        setStep('form');
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);
                        setStep('form');
                    }else
                    {
                        onOk(res.result);
                    }
         } )
         .catch(err => {
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    setStep('form');
         });
    }



    const generate = () => {

        if(row.domena.length < 4)
        {
            props.mainView.showDialog( "Ups!", "Podaj nazwę domeny" , "error" , null);
            return;
        }

        setStep('wait');
        setChallenges([]);
        setLog('');
        setQueued(false);

        request('ssl_generate', { domena: row.domena, wildcard: row.wildcard ? 1 : 0 }, (t) => {
            setToken(t);
        });
    }


    const confirmDns = () => {
        setStep('wait'); //wznawia odpytywanie statusu
        request('ssl_continue', { token: token }, () => {});
    }


    const checkStatus = () => {

        request('ssl_status', { token: token }, (st) => {

            setChallenges(st.challenges);

            if(st.status == 'waiting_dns') { setStep('dns'); return; }
            if(st.status == 'error')       { setStep('error'); setLog(st.log); return; }
            if(st.status == 'done')        { setStep('done'); props.mainView.toast("Certyfikat wygenerowany"); return; }

            // queued / starting / running
            setQueued(st.status == 'queued');
            timerRef.current = setTimeout(checkStatus, 3000);
        });
    }


    // odpytuj status, gdy czekamy na certbota
    useEffect( () => {

        if(step == 'wait' && token != null)
        {
            timerRef.current = setTimeout(checkStatus, 2000);
        }

        return () => { clearTimeout(timerRef.current); };

    }, [step, token] );



    document.title = 'Wygeneruj certyfikat SSL';


    var domains = row.domena;
    if(row.wildcard) domains = '*.' + row.domena + ', ' + row.domena;


    return <div className="view_content">

                {
                    step != 'wait' && step != 'dns' &&
                    <img src={back} onClick={step == 'done' ? props.onSuccess : props.onBack} className="back_img" title="wstecz"/>
                }

                <div className="app_header">Wygeneruj certyfikat SSL</div>

                  <form className="eForm bg_center">


                        <div className="form_tab_title">Domena:</div>
                        <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa domeny*</div>
                                                <InputText   userData={props.userData} value={row.domena}  valChange={valChangeListener} goNext={goNextNew} name="domena" placeholder={"Domena: np. progressplus.pl"} className=' w300 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Wildcard</div>
                                                <InputChecbox  title={"*.domena (wildcard)"}  userData={props.userData}  checked={row.wildcard ? '1' : '0'} value={'1'} valChange={valChangeListener}  name="wildcard"   className=' ' req='0' />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                Certyfikat Let's Encrypt, ważny 90 dni. Weryfikacja przez rekord TXT w DNS.
                                            </div>
                        </div>


                        {
                            step == 'wait' &&
                            <div className="form_tab">
                                {
                                    queued ? 'Zlecenie czeka w kolejce na zakończenie innego generowania: '
                                           : 'Trwa generowanie certyfikatu dla: '
                                }
                                <b>{domains}</b> ...
                            </div>
                        }


                        {
                            step == 'dns' &&
                            <div>
                                <div className="form_tab_title">Dodaj rekordy TXT w DNS:</div>
                                <div className="form_tab">

                                    <table className="table">
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">Nazwa</td>
                                                <td>Typ</td>
                                                <td className="td_right">Wartość</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                challenges.map( (ch, ix) => {
                                                    return <tr className={ix % 2 == 0 ? " row2 " : " row "} key={ix}>
                                                        <td>{ch.nazwa}</td>
                                                        <td className="gocenter">TXT</td>
                                                        <td>{ch.wartosc}</td>
                                                    </tr>
                                                } )
                                            }
                                        </tbody>
                                    </table>

                                    <br/>
                                    Po dodaniu rekordów odczekaj, aż DNS się rozpropaguje (sprawdź: <i>dig TXT {challenges.length > 0 ? challenges[0].nazwa : ''}</i>), i kliknij „kontynuuj”.
                                </div>
                            </div>
                        }


                        {
                            step == 'error' &&
                            <div>
                                <div className="form_tab_title">Błąd generowania:</div>
                                <div className="form_tab">
                                    <pre style={{whiteSpace: 'pre-wrap'}}>{log}</pre>
                                </div>
                            </div>
                        }


                        {
                            step == 'done' &&
                            <div className="form_tab">
                                Certyfikat dla <b>{domains}</b> został wygenerowany.
                            </div>
                        }


                        <div className="form_split"></div>

                                <div className="form_btn">
                                        {
                                            (step == 'form' || step == 'error') &&
                                            <div className="btn" onClick={generate}>wygeneruj certyfikat</div>
                                        }
                                        {
                                            step == 'dns' &&
                                            <div className="btn" onClick={confirmDns}>rekordy dodane - kontynuuj</div>
                                        }
                                        {
                                            step == 'done' &&
                                            <div className="btn" onClick={props.onSuccess}>wróć do listy</div>
                                        }
                                        {
                                            (step == 'form' || step == 'error') &&
                                            <span>&nbsp;&nbsp;<div className="btn" onClick={props.onBack}    > anuluj [back]</div></span>
                                        }
                        </div>


                  </form>

    </div>


}


export default SslForm;
